<template>
  <div>
    <p>
      <strong>Quem tem direito?</strong>
    </p>
    <p>
      Pessoas com deficiência ou com hemofilia, comprovadamente carentes, ou
      seja, aqueles que comprovem renda familiar mensal per capita inferior a ¼
      (um quarto) do salário-mínimo, nos termos da Lei Federal nº 8.742/1993, e
      pessoas vivendo com HIV e AIDS, devidamente diagnosticadas.
    </p>
    <p>
      <strong>Quais documentos necessários?</strong>
      <ul>
        <li>Formulário de Concessão (Impresso ao término do cadastro);</li>
        <li>Laudo
      Médico de Avaliação, devidamente atestado por Médico Especialista,
      vinculado à Rede do SUS;</li>
      <li>Dispensa-se a apresentação do Laudo Médico de
      Avaliação da Deficiência, caso a pessoa interessada enquadre-se em alguma
      das seguintes situações:
        <ol>
          <li>I – Seja beneficiária do Benefício de Prestação
      Continuada (BPC) da Lei Orgânica da Assistência Social (LOAS), comprovando
      através de cópia da carta de concessão ou de cópia do cartão de
      recebimento do benefício ativo, concedido e recebido no Ceará, e/ou de
      documento expedido pelo Instituto Nacional do Seguro Social (INSS) que
      ateste tal condição, sendo obrigatória cópia do documento de identidade
      (RG) do titular quando este e o requerente não forem a mesma pessoa;</li>
      <li>II –
      Seja beneficiária da gratuidade para pessoas com deficiência nos Sistemas
      de Transporte Público de Fortaleza e do Governo Federal, comprovando
      através da cópia do cartão da gratuidade.</li>
        </ol>
      </li>
      <li>Documento oficial com foto e
      com número do CPF. Se necessário para dirimir eventuais dúvidas acerca da
      grafia e/ou alterações/variações do nome do beneficiário, apresentar um
      dos seguintes documentos:
        <ol>
          <li>a) certidão de nascimento;</li>
          <li>b) certidão de
      casamento; </li>
      <li>c) certificado de reservista; </li>
      <li>d) carteira de trabalho e
      previdência social; </li>
      <li>e) título eleitoral</li>
        </ol>
      </li>
      <li>Comprovante atualizado de
      residência no Estado do Ceará (com CEP);</li>
      <li>02
      (duas) fotos 3x4 originais, recentes, coloridas e com fundo branco (apenas
      para o interior);</li>
      <li>Declaração de Renda emitida pelo CRAS ou Declaração
      de Carência</li>
      </ul>
    </p>
    <p>
      <strong>1° Passo</strong>
      Realize o seu cadastro inicialmente informando o CPF.
    </p>
    <p>
      <strong>2° Passo</strong>
      Encaminhar-se com os respectivos exames a um Médico Especialista,
      vinculado à Rede do SUS, de posse do Laudo Médico de Avaliação, para
      atestar a deficiência. Qual critério para dispensa do Laudo Médico de
      Avaliação? Para pessoas com Hemofilia, obter declaração junto ao HEMOCE.
      Para pessoas vivendo com HIV e AIDS, obter o Formulário de Solicitação de
      Medicamentos - Tratamento.
    </p>
    <p>
      <strong>3° Passo</strong>
      Comparecer a uma unidade do CRAS para obter/atestar declaração de Renda
      Familiar Mensal Per Capita informando sua condição socioeconômica, com
      validade de até 180 (cento e oitenta) dias entre sua expedição e a
      apresentação para o requerimento de inscrição da gratuidade. No caso de
      beneficiários do programa governamental de benefício assistencial BPC/LOAS
      comparecer a uma agência do INSS para obter documento que comprove que o
      benefício está ativo/válido ou anexar cópia do cartão de recebimento do
      benefício ativo, dentro da validade. OBS: Esse passo é dispensado para
      pessoas vivendo com HIV e AIDS, devidamente diagnosticadas ( ou seja, é
      dispensada a declaração de carência ). Como proceder caso não possua a
      declaração atestando a condição socioeconômica? Modelo da Declaração de
      Carência.
    </p>
    <p>
      <strong>4° Passo</strong>
      Entregar a documentação necessária* junto aos pontos de atendimento da
      região metropolitana ou do interior.
    </p>
    <p>
      <strong>5° Passo</strong>
      A ARCE/CE realizará a análise do processo.
    </p>
    <p>
      <strong>6° Passo</strong>
      Recebimento da carteira.
    </p>
  </div>
</template>

<script>
export default {
  name: "Orientacoes"
};
</script>

<style lang="scss">
strong {
  display: block;
  text-transform: uppercase;
}
p {
  text-align: justify;
}
</style>
